import { Component } from '@angular/core';
import { ComponentRef } from '@angular/core';
import { ViewChild } from '@angular/core';

import { BasePortalHost } from 'app/ui/core/portal';
import { ComponentPortal } from 'app/ui/core/portal';
import { UIPortalHostDirective } from 'app/ui/core/portal-directives';
import { TemplatePortal } from 'app/ui/core/portal';

@Component({
    selector: 'ui-snack-bar',
    template: '<ng-template cdkPortalHost></ng-template>',
    styleUrls: ['snack-bar.component.scss']
})
export class UISnackBarComponent extends BasePortalHost {

    @ViewChild(UIPortalHostDirective) portalHost: UIPortalHostDirective;

    constructor() {
        super();
    }

    attachComponentPortal<T>(portal: ComponentPortal<T>): ComponentRef<T> {
        return this.portalHost.attachComponentPortal(portal);
    }

    attachTemplatePortal(portal: TemplatePortal): void {
        this.portalHost.attachTemplatePortal(portal);
    }

}